const JWT_PATTERN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

export const isValidJwtToken = (token) => typeof token === 'string' && JWT_PATTERN.test(token);

export const getStoredAuthToken = () => {
  const token = localStorage.getItem('token');
  return isValidJwtToken(token) ? token : null;
};

export const clearStoredAuth = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('refreshToken');
};

export const getStoredRefreshToken = () => {
  const token = localStorage.getItem('refreshToken');
  return isValidJwtToken(token) ? token : null;
};

export const storeTokens = (token, refreshToken) => {
  if (token) localStorage.setItem('token', token);
  if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
};